import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

const ManagePermissionsMenuItem = ({Icon, itemId, title, rowData, onOpen, handleClose}) => {
    const {t} = useTranslation()

    const handleClick = (event) => {
        event?.stopPropagation()
        handleClose(event)
        onOpen?.(rowData)
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={handleClick}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default ManagePermissionsMenuItem
